module.exports = __webpack_public_path__ + "img/topgqy_bg.5782a7dd.png";